<script setup lang="ts">
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'

const faqItems = [
  {
    value: 'item-1',
    id: 'negative-history',
    question: 'У меня были просрочки по займам. Могу ли я обратиться за займом к Вам?',
    answer: 'Мы рассматриваем заявки от клиентов, имеющих негативную кредитную историю по прошлым займам и кредитам, и принимаем каждое решение индивидуально.',
  },
  {
    value: 'item-2',
    id: 'conditions',
    question: 'Какие условия получения займа?',
    answer: '— гражданство Российской Федерации<br>— регистрация на территории РФ<br>— возраст от 18 до 88 лет<br>— наличие постоянного дохода',
  },
  {
    value: 'item-3',
    id: 'loan-time',
    question: 'В какой срок выдаются деньги?',
    answer: 'Обычно средства поступают в течение пары минут после подписания документов.',
  },
  {
    value: 'item-4',
    id: 'how-get-money',
    question: 'Как я получу деньги?',
    answer: '— на имеющуюся у вас банковскую карту',
  },
  {
    value: 'item-5',
    id: 'comissions',
    question: 'Имеются ли какие-либо комиссии и скрытые платежи?',
    answer: 'Нет, не имеются. В процессе оформления займа указана детальная и вся необходимая информация, включая информацию о страховке. Пожалуйста, изучайте подробно все нюансы во избежание негатива в рамках сотрудничества с нами.',
  },
  {
    value: 'item-6',
    id: 'how-pay',
    question: 'Какими способами можно вернуть займ?',
    answer: '— вашей банковской картой Visa/MasterCard/МИР<br>— используя Ваш онлайн-банк<br>— через офисы Сбербанк',
  },
  {
    value: 'item-7',
    id: 'early-pay',
    question: 'Возможно ли досрочное погашение?',
    answer: 'Да, на любом сроке, с перерасчетом суммы только за фактическое время пользования денежными средствами и с обязательным предварительным уведомлением.',
  },
  {
    value: 'item-8',
    id: 'discount',
    question: 'Есть ли у вас льготные условия для постоянных клиентов?',
    answer: 'Конечно, если вы являетесь нашим постоянным клиентом, вы можете получить заём на более выгодных для вас условиях.',
  },
  {
    value: 'item-9',
    id: 'sms-code',
    question: 'Почему не приходит код из смс?',
    answer: `
    Основные причины:  <br> <br>

 <b>1. Неполадки с устройством клиента:</b>   <br>
   - Недостаточно памяти  <br>
   - Устройство не поддерживает SMS   <br>
   - Переполнен список Входящих сообщений <br> <br>

<b>2. Сложности с SIM-картой и сетью:</b> <br>
   - Неисправная или неправильно вставленная SIM-карта  <br>
   - Нет сети или абонент вне зоны покрытия  <br>
   - Перегрузка операторской сети  <br> <br>

<b>3. Блокировки и ограничения:</b>  <br>
   - Номер в черном списке <br>
   - SMS попадают в спам  <br>
   - Блокировка антиспамом или приложениями на устройстве <br>
   - Абонент запретил рассылку <br> <br>

<b>4. Проблемы с номером и счетом:</b>  <br>
   - Введен неверный или несуществующий номер  <br>
   - Номер не зарегистрирован у оператора  <br>
   - Отрицательный баланс или блокировка SIM  <br>
   - Роуминг без поддержки SMS  <br> <br>

<b>5. Технические и системные сбои:</b>  <br>
   - Ошибки после смены SIM-карты  <br>
   - Превышен лимит отправки сообщений  <br>
   - Проблемы на стороне оператора  <br> <br>

<b>В большинстве случаев SMS доставляются мгновенно, если нет перечисленных проблем.</b>`,
  },
]
const route = useRoute()
const openItems = ref<string[]>([])
const scrollOffset = 100
onMounted(() => {
  if (route.query['sms-not-sended']) {
    openItems.value = [...openItems.value, 'item-9']

    nextTick(() => {
      setTimeout(() => {
        const element = document.getElementById('sms-code')
        if (element) {
          const elementTop = element.getBoundingClientRect().top + window.scrollY
          const offsetPosition = elementTop - scrollOffset

          window.scrollTo({
            top: offsetPosition,
          })
        }
      }, 0)
    })
  }
})
</script>

<template>
  <section id="faq" class="py-16 bg-gray-100">
    <div class="container mx-auto px-4">
      <div class="text-center mb-6">
        <h2 class="text-3xl font-bold text-title mb-2">
          Вопросы и ответы
        </h2>
        <p class="text-gray-600">
          Часто задаваемые вопросы
        </p>
      </div>

      <Accordion v-model="openItems" type="multiple" class="w-full" collapsible>
        <AccordionItem
          v-for="(item, index) in faqItems"
          :id="item.id"
          :key="index"
          :value="item.value"
          class="border-b border-gray-200 hover:bg-white px-4 rounded-lg hover:shadow data-[state=open]:bg-white"
        >
          <AccordionTrigger class="py-4 hover:no-underline">
            <span class="text-left text-lg font-medium text-title">{{ item.question }}</span>
          </AccordionTrigger>

          <AccordionContent class="pb-4 text-gray-600 leading-relaxed">
            <div class="pl-1" v-html="item.answer" />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  </section>
</template>

<style>
:deep([data-accordion-icon]) {
  transition: transform 0.2s ease;
  color: #3b82f6;
}
</style>
